// extracted by mini-css-extract-plugin
module.exports = {"colorGrid":"ColorSelector_colorGrid__29dNs","colorButton":"ColorSelector_colorButton__29x3q","selected":"ColorSelector_selected__69pi1"};